<template>
  <div
    id="login_main"
    v-loading="pageLoading"
    tabindex="0"
  >
    <transition name="el-zoom-in-center">
      <div
        v-show="loginState === 'login'"
        id="loginDiv"
      >
        <div class="loginDivWrap">
          <div class="left">
            <div class="header">
              <div class="header-brand">
                <img
                  src="@/assets/img/login/logo-management.png"
                  alt="智生活"
                >
              </div>
              <i
                class="icon-burger burger-bar sm-size"
                aria-hidden="true"
                @click="collapseLinkBox=true"
              />
              <div
                id="burger-menu"
                :class="{'in': collapseLinkBox}"
                class="sm-size collapse"
              >
                <ul>
                  <li>
                    <i
                      class="icon-close"
                      @click="collapseLinkBox=false"
                    />
                  </li>
                  <li>
                    <a
                      href="https://www.smartdaily.com.tw/services.html"
                      target="_blank"
                      rel="noopener"
                    >產品資訊</a>
                  </li>
                  <li>
                    <a
                      href="https://knst.tw/7p9pal"
                      target="_blank"
                      rel="noopener"
                    >免費申請</a>
                  </li>
                  <li>
                    <a
                      href="https://www.smartdaily.com.tw/questions/app"
                      target="_blank"
                      rel="noopener"
                    >App下載</a>
                  </li>
                  <li>
                    <a
                      href="https://www.smartdaily.com.tw/smartdailyfaq.html"
                      target="_blank"
                      rel="noopener"
                    >使用教學</a>
                  </li>
                </ul>
              </div>
            </div>
            <div class="main">
              <div
                class="main-pane"
                @keydown.13.prevent="handleClickEnter"
              >
                <img
                  class="sm-size"
                  src="@/assets/img/login/sketch.png"
                  alt=""
                >
                <div
                  v-show="exceptionState === 'login'"
                  class="login-area login-procedure"
                >
                  <el-tabs
                    v-model="tabActive"
                    @tab-click="handleTabClick"
                  >
                    <el-tab-pane
                      label="帳號密碼登入"
                      name="tab-username"
                    >
                      <div
                        id="tab-username"
                        class="tab-pane fade active in"
                      >
                        <el-form
                          ref="loginAccountDom"
                          :model="loginAuth"
                          :rules="loginAuthRules"
                          @submit.native.prevent
                        >
                          <el-form-item prop="username">
                            <el-input
                              ref="loginUsernameDom"
                              v-model="loginAuth.username"
                              placeholder="請輸入社區帳號密碼或個人手機帳號"
                              tabindex="1"
                            />
                          </el-form-item>
                          <el-form-item prop="password">
                            <el-input
                              v-model="loginAuth.password"
                              type="password"
                              placeholder="請輸入密碼"
                              tabindex="2"
                            />
                          </el-form-item>
                        </el-form>
                        <div class="remember">
                          <el-checkbox v-model="accountRemember">
                            記住帳號
                          </el-checkbox>
                        </div>
                        <p class="errMsg dangerText">
                          帳號密碼錯誤，請重新輸入
                        </p>
                        <div class="submit mainBtn" @click="loginByAccount()">
                          {{ $t('LoginMain.Login') }}
                        </div>
                        <div class="loginOptionBlock">
                          <div
                            class="cannotLogin linkText link"
                            @click="switchExceptionState('register')"
                          >
                            註冊帳號
                          </div>
                          <div
                            class="cannotLogin linkText link"
                            @click="switchExceptionState('select')"
                          >
                            忘記密碼 / 使用一次性密碼
                          </div>
                        </div>
                      </div>
                    </el-tab-pane>
                    <el-tab-pane
                      label="QR Code登入"
                      name="tab-qrcode"
                    >
                      <div
                        id="tab-qrcode"
                        :class="{'invalid':loginData.qrcodeDue}"
                        class="tab-pane fade"
                      >
                        <p>請登入<span class="mainText">智生活管理APP</span>使用掃描登入</p>
                        <div
                          id="loginQrcode"
                          class="default"
                        >
                          <i
                            class="icon-refresh reload"
                            aria-hidden="true"
                            @click="handleReloadQrcode()"
                          />
                          <vue-qr
                            v-if="loginData.qrcodeData"
                            :correct-level="3"
                            :text="loginData.qrcodeData"
                            :size="190"
                            :margin="0"
                          />
                          <img
                            v-else
                            class="defaultPattern"
                            src="@/assets/img/login/loading.gif"
                            alt="QRcode產生中..."
                          >
                        </div>
                        <p class="invalidTip dangerText">
                          二維碼已失效，請重新點擊產生條碼
                        </p>
                        <p class="tip">
                          <span
                            class="linkText link"
                            @click="exceptionState = 'select'"
                          >忘記密碼 / 使用一次性密碼</span>
                          <br>
                          查看
                          <span><a
                            class="linkText link"
                            href="https://www.smartdaily.com.tw/questions"
                            target="_blank"
                            rel="noopener"
                          >常見問題</a></span>
                        </p>
                      </div>
                    </el-tab-pane>
                  </el-tabs>
                </div>
                <div
                  v-show="exceptionState === 'select'"
                  class="login-solutionSelect login-procedure"
                >
                  <h3 class="titleText">
                    登入智生活管理版
                  </h3>
                  <p class="subtitleText">
                    請使用社區代碼或個人手機號碼登入
                  </p>
                  <div class="optionWrap">
                    <div
                      class="optionItem optionBtn"
                      @click="switchExceptionState('forget1')"
                    >
                      忘記密碼
                    </div>
                    <div
                      class="optionItem optionBtn"
                      @click="exceptionState = 'temppwd'"
                    >
                      使用一次性密碼登入（限新版權限）
                    </div>
                  </div>
                  <div
                    class="back linkText link mainText"
                    @click="exceptionState = 'login'"
                  >
                    返回登入畫面
                  </div>
                </div>
                <div
                  v-show="exceptionState === 'temppwd'"
                  class="login-solutionTemp login-procedure"
                >
                  <h3 class="titleText">
                    使用一次性密碼登入
                  </h3>
                  <p>若您的社區採用新版登入權限，您可向社區最高管理員取得一次性密碼登入</p>
                  <el-form
                    ref="loginTempSnDom"
                    :model="loginAuth"
                    :rules="loginAuthRules"
                    @submit.native.prevent
                  >
                    <el-form-item prop="tempSn">
                      <el-input
                        v-model="loginAuth.tempSn"
                        autocomplete="off"
                        placeholder="請輸入一次性的登入密碼"
                      />
                    </el-form-item>
                  </el-form>
                  <p>登入注意事項:</p>
                  <p>1.一次性密碼需於3天內使用，登入後可使用24小時，請向最高管理者索取一次性密碼</p>
                  <p>2.一次性密碼僅限一台電腦登入一次</p>
                  <div
                    class="mainBtn"
                    @click="loginBySn()"
                  >
                    登入
                  </div>
                  <div
                    class="back link mainText"
                    @click="exceptionState = 'login'"
                  >
                    返回登入畫面
                  </div>
                </div>
              </div>
              <div v-show="exceptionState === 'register'" class="login-solutionRegister login-procedure">
                <el-row type="flex" justify="center">
                  <el-col :md="20" :lg="18" :xl="16">
                    <h3 class="titleText">
                      社區管理人員帳號註冊
                    </h3>
                    <el-form
                      ref="registerForm"
                      :model="registerData"
                      label-width="100px"
                      :rules="registerRules"
                      :label-position="isSmallScreen ? 'top' : ''"
                    >
                      <el-form-item
                        label="姓名"
                        prop="name"
                      >
                        <el-input
                          v-model="registerData.name"
                          type="text"
                          class="registerInput"
                          maxlength="20"
                          placeholder="請輸入真實中文姓名"
                          @input="filterValidValue('name')"
                        />
                      </el-form-item>
                      <el-form-item
                        label="手機號碼"
                        prop="cellphone"
                      >
                        <el-row type="flex">
                          <el-input
                            v-model="registerData.cellphone"
                            type="tel"
                            class="registerInput cellphoneInput"
                            maxlength="10"
                            placeholder="請輸入正確手機號碼"
                            @change="isCellphoneRigistrated = null"
                            @input="filterValidValue('cellphone')"
                          />
                          <template v-if="!isSmallScreen">
                            <div class="messageWrap">
                              <el-button
                                v-if="!showTimer"
                                size="medium"
                                :disabled="!canSendVerificationCode"
                                @click.prevent="sendVerificationCode"
                              >
                                發送驗證碼
                              </el-button>
                              <a
                                class="noMessageLink"
                                href="https://knst.tw/989wwl"
                                target="_blank"
                                rel="noopener"
                              >
                                收不到驗證碼？
                              </a>
                              <el-button
                                v-if="showTimer"
                                size="medium"
                                disabled
                              >
                                {{ second }} 秒
                              </el-button>
                            </div>
                          </template>
                          <template v-else>
                            <div
                              v-if="!showTimer"
                              class="link mainText"
                              :class="{'disable': !canSendVerificationCode}"
                              @click="sendVerificationCode"
                            >
                              發送驗證碼
                            </div>
                            <div
                              v-else
                              class="mainText"
                            >
                              {{ second }} 秒
                            </div>
                          </template>
                        </el-row>
                      </el-form-item>
                      <el-form-item
                        label="手機驗證碼"
                        prop="verificationCode"
                      >
                        <template slot="label">
                          手機驗證碼
                          <a
                            v-if="isSmallScreen"
                            class="noMessageLink"
                            href="https://knst.tw/989wwl"
                            target="_blank"
                            rel="noopener"
                          >
                            收不到驗證碼？
                          </a>
                        </template>
                        <el-input
                          v-model="registerData.verificationCode"
                          name="verificationCode"
                          type="text"
                          class="registerInput"
                          maxlength="6"
                          placeholder="請輸入手機簡訊驗證碼"
                          autocomplete="verificationCode"
                          @change="isVerificationCodeError = false"
                          @input="filterValidValue('verificationCode')"
                        />
                        <div v-if="smsHintMessage !== ''" class="el-form-item__error" style="position: unset">
                          {{ smsHintMessage }}
                        </div>
                      </el-form-item>
                      <el-form-item
                        label="密碼"
                        prop="password"
                      >
                        <el-input
                          v-model="registerData.password"
                          name="password"
                          type="password"
                          class="registerInput"
                          maxlength="6"
                          placeholder="請輸入6位數字密碼"
                          autocomplete="password"
                          show-password
                          @input="filterValidValue('password')"
                        />
                      </el-form-item>
                      <el-form-item
                        label="確認密碼"
                        prop="password2"
                      >
                        <el-input
                          v-model="registerData.password2"
                          type="password"
                          class="registerInput"
                          maxlength="6"
                          placeholder="請再一次輸入密碼"
                          show-password
                          @input="filterValidValue('password2')"
                        />
                      </el-form-item>
                    </el-form>
                    <el-row
                      type="flex"
                      justify="center"
                    >
                      <el-button
                        v-if="!isSmallScreen"
                        round
                        @click="closeRegister"
                      >
                        取消
                      </el-button>
                      <el-button
                        type="primary"
                        class="rigistrationBtn"
                        round
                        @click="sendRegistration('registerForm')"
                      >
                        註冊
                      </el-button>
                    </el-row>
                    <div
                      v-if="isSmallScreen"
                      class="link mainText"
                      @click="closeRegister"
                    >
                      返回登入畫面
                    </div>
                  </el-col>
                </el-row>
              </div>
              <div v-show="exceptionState === 'registerSuccess'" class="login-procedure">
                <el-row type="flex" justify="center">
                  <el-col :md="20" :lg="18" :xl="16" class="registerSuccess-container">
                    <i
                      class="icon-correct"
                      aria-hidden="true"
                    />
                    <h3>
                      {{ $t('LoginMain.RegisterSuccessTitle') }}
                    </h3>
                    <div class="registerSuccessText">
                      <p>
                        {{ $t('LoginMain.RegisterSuccessText1') }}
                      </p>
                      <p>
                        {{ $t('LoginMain.RegisterSuccessText2') }}
                      </p>
                    </div>
                    <el-button
                      type="primary"
                      round
                      @click="backToLogin"
                    >
                      {{ $t('LoginMain.LoginAndOpenCommunity') }}
                    </el-button>
                  </el-col>
                </el-row>
              </div>
              <div
                v-show="exceptionState === 'forget1' || exceptionState === 'forget2'"
                class="login-solutionForget login-procedure"
              >
                <el-row
                  type="flex"
                  justify="center"
                >
                  <el-col
                    :md="20"
                    :lg="18"
                    :xl="16"
                  >
                    <h3 class="titleText">
                      忘記密碼
                    </h3>
                    <el-form
                      v-show="exceptionState === 'forget1'"
                      ref="forgetPasswordForm1"
                      :model="registerData"
                      label-width="100px"
                      :rules="registerRules"
                      :label-position="isSmallScreen ? 'top' : ''"
                    >
                      <el-form-item
                        label="手機號碼"
                        prop="cellphone"
                      >
                        <el-row type="flex">
                          <el-input
                            v-model="registerData.cellphone"
                            type="tel"
                            class="registerInput cellphoneInput"
                            maxlength="10"
                            placeholder="請輸入正確手機號碼"
                            @change="isCellphoneRigistrated = null"
                            @input="filterValidValue('cellphone')"
                          />
                          <template v-if="!isSmallScreen">
                            <div class="messageWrap">
                              <el-button
                                v-if="!showTimer"
                                size="medium"
                                :disabled="!canSendVerificationCode"
                                @click.prevent="sendVerificationCode"
                              >
                                發送驗證碼
                              </el-button>
                              <a
                                class="noMessageLink"
                                href="https://knst.tw/989wwl"
                                target="_blank"
                                rel="noopener"
                              >
                                收不到驗證碼？
                              </a>
                              <el-button
                                v-if="showTimer"
                                size="medium"
                                disabled
                              >
                                {{ second }} 秒
                              </el-button>
                            </div>
                          </template>
                          <template v-else>
                            <div
                              v-if="!showTimer"
                              class="link mainText"
                              :class="{'disable': !canSendVerificationCode}"
                              @click="sendVerificationCode"
                            >
                              發送驗證碼
                            </div>
                            <div
                              v-else
                              class="mainText"
                            >
                              {{ second }} 秒
                            </div>
                          </template>
                        </el-row>
                      </el-form-item>
                      <el-form-item
                        label="手機驗證碼"
                        prop="verificationCode"
                      >
                        <template slot="label">
                          手機驗證碼
                          <a
                            v-if="isSmallScreen"
                            class="noMessageLink"
                            href="https://knst.tw/989wwl"
                            target="_blank"
                            rel="noopener"
                          >
                            收不到驗證碼？
                          </a>
                        </template>
                        <el-input
                          v-model="registerData.verificationCode"
                          type="text"
                          class="registerInput"
                          maxlength="6"
                          placeholder="請輸入手機簡訊驗證碼"
                          @change="isVerificationCodeError = false"
                          @input="filterValidValue('verificationCode')"
                        />
                      </el-form-item>
                      <el-row
                        type="flex"
                        justify="center"
                      >
                        <el-button
                          v-if="!isSmallScreen"
                          round
                          @click="closeRegister"
                        >
                          取消
                        </el-button>
                        <el-button
                          type="primary"
                          class="rigistrationBtn"
                          round
                          @click="sendRegistration('forgetPasswordForm1')"
                        >
                          下一步
                        </el-button>
                      </el-row>
                      <div
                        v-if="isSmallScreen"
                        class="link mainText"
                        @click="closeRegister"
                      >
                        返回登入畫面
                      </div>
                    </el-form>
                    <el-form
                      v-show="exceptionState === 'forget2'"
                      ref="forgetPasswordForm2"
                      :model="registerData"
                      label-width="100px"
                      :rules="registerRules"
                      :label-position="isSmallScreen ? 'top' : ''"
                    >
                      <el-form-item
                        label="新密碼"
                        prop="password"
                      >
                        <el-input
                          v-model="registerData.password"
                          type="password"
                          maxlength="6"
                          placeholder="請設定6位數字密碼"
                          autocomplete="off"
                          show-password
                          @input="filterValidValue('password')"
                        />
                      </el-form-item>
                      <el-form-item
                        label="確認密碼"
                        prop="password2"
                      >
                        <el-input
                          v-model="registerData.password2"
                          type="password"
                          maxlength="6"
                          placeholder="請再次輸入密碼"
                          show-password
                          @input="filterValidValue('password2')"
                        />
                      </el-form-item>
                      <el-row
                        type="flex"
                        justify="center"
                      >
                        <el-button
                          v-if="!isSmallScreen"
                          round
                          @click="closeRegister"
                        >
                          取消
                        </el-button>
                        <el-button
                          type="primary"
                          class="rigistrationBtn"
                          round
                          @click="sendRegistration('forgetPasswordForm2')"
                        >
                          送出
                        </el-button>
                      </el-row>
                      <div
                        v-if="isSmallScreen"
                        class="link mainText"
                        @click="closeRegister"
                      >
                        返回
                      </div>
                    </el-form>
                  </el-col>
                </el-row>
              </div>
            </div>
            <div class="footer">
              <p class="sm-size copyRight">
                {{ $t('General.Copyright1') }}
                <br>
                {{ $t('General.Copyright2', { thisYear: new Date().getFullYear() }) }}
              </p>
            </div>
          </div>
          <div class="right">
            <div class="header">
              <ul>
                <li>
                  <a
                    href="https://www.smartdaily.com.tw/services.html"
                    target="_blank"
                  >產品資訊</a>
                </li>
                <li>
                  <a
                    href="https://knst.tw/7p9pal"
                    target="_blank"
                  >免費申請</a>
                </li>
                <li>
                  <a
                    href="https://www.smartdaily.com.tw/questions/app"
                    target="_blank"
                  >App下載</a>
                </li>
                <li>
                  <a
                    href="https://www.smartdaily.com.tw/smartdailyfaq.html"
                    target="_blank"
                  >使用教學</a>
                </li>
              </ul>
            </div>
            <div class="main">
              <div class="main-pane">
                <img
                  src="@/assets/img/login/sketch.png"
                  alt=""
                >
              </div>
            </div>
            <div class="footer">
              <p class="copyRight">
                {{ $t('General.Copyright1') }}
                <br>
                {{ $t('General.Copyright2', { thisYear: new Date().getFullYear() }) }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <transition name="el-zoom-in-center">
      <div
        v-show="loginState === 'community'"
        id="communityDiv"
        class="showImageDiv"
      >
        <div class="communityDivWrap">
          <div class="left">
            <div class="header">
              <div class="header-brand">
                <img
                  src="@/assets/img/login/logo-management.png"
                  alt="智生活"
                >
              </div>
            </div>
            <div class="main">
              <div class="main-pane">
                <img
                  src="@/assets/img/login/sketch.png"
                  alt=""
                >
              </div>
            </div>
          </div>
          <div class="right">
            <div class="main">
              <div class="main-pane">
                <h3 class="titleText">
                  請選擇您要登入社區
                </h3>
                <div class="communityWrap">
                  <p>管理員 {{ loginData.adminName }}，您好</p>
                  <div v-loading="isCommunitySelectLoading" class="communitySelect">
                    <div
                      v-for="val in loginData.communities"
                      :key="val.comId"
                      class="communityItem optionBtn"
                      @click="confirmLogin(val.comId, val.comName)"
                    >
                      {{ val.comName }}
                    </div>
                  </div>
                </div>
                <div class="btnWrap">
                  <span
                    v-if="loginData.isAuthorizationAccount"
                    class="linkText link"
                    @click="openCommunityOpenDialog"
                  >{{ $t('LoginMain.OpenNewCommunity') }}</span>
                  <span
                    class="linkText link logout"
                    @click="logoutUser()"
                  >{{ $t('LoginMain.Logout') }}</span>
                </div>
              </div>
            </div>
            <div class="community-footer">
              <div class="footer-right">
                <div class="title">
                  立即加入社群
                </div>
                <div class="property-link">
                  <a href="https://www.smartdaily.com.tw/manage-community/" target="_blank">
                    查看社群討論內容
                  </a>
                </div>
                <div class="qr-code">
                  <div class="content">
                    <img src="../assets/img/property/line-qrcode.png">
                  </div>
                </div>
              </div>
              <div class="footer-left">
                <div class="title">
                  邀你加入物業保全社群，工作疑問立即提問不卡關！
                </div>
                <div>
                  <div>系統操作問題有行業前輩與官方小編回答！</div>
                  <div>法規、職場人際等工作疑問討論分享</div>
                  <div>超實用免費物業培訓課程搶先報名</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <community-open-dialog
      v-model="isOpenCodeDialog"
      :token="loginData.communityAdminToken"
      :is-show-cancel-alert="communityOpenDialogSetting.isShowCancelAlert"
      :is-re-login-alert="communityOpenDialogSetting.isReLoginAlert"
      @success="handleCommunityOpenSuccess"
    />
    <register-sw
      ref="registerSw"
      @getToken="isLogin"
      @login="loginByQrcode"
    />
    <!-- 偵測瀏覽器 -->
    <div
      v-if="showBrowserNotify"
      class="showBrowserDiv"
    >
      <div class="modal-browser-overlay" />
      <div class="modal-browser">
        <h4>{{ $t('LoginMain.PleaseUseChrome') }}</h4>
        <p>如尚未安裝，可點選以下圖示進行下載安裝</p>
        <div>
          <a href="https://www.google.com/chrome/browser/desktop/index.html">
            <img
              src="@/assets/img/login/chrome.png"
              alt="前往下載chrome瀏覽器"
            >
          </a>
        </div>
      </div>
    </div>
    <!-- /偵測瀏覽器 -->
  </div>
</template>
<script>
import UAParser from 'ua-parser-js'
import RegisterSwFrame from '@/components/RegisterSwFrame'
import { isValidCellphone } from '@/js/utils/unitValidate'
import { apiMvc } from '@/api/mvc'
import CommunityOpenDialog from '@/components/CommunityOpenDialog'
import { housekeeperAPI } from '@/api/HousekeeperAPI'

export default {
  components: {
    'register-sw': RegisterSwFrame,
    'community-open-dialog': CommunityOpenDialog
  },
  data () {
    const checkForm = (rule, value, callback) => {
      const nameRegex = /^[a-zA-Z0-9_\u4e00-\u9fa5]+$/
      const passwordRegex = /^\d{6}$/
      switch (rule.field) {
      case 'name':
        if (!value) {
          return callback(new Error('姓名不可為空'))
        } else if (!nameRegex.test(value)) {
          return callback(new Error('姓名格式錯誤，請輸入正確姓名'))
        } else {
          callback()
        }
        break
      case 'cellphone':
        if (!value) {
          return callback(new Error('手機號碼不可為空'))
        } else if (!isValidCellphone(value)) {
          return callback(new Error('手機格式錯誤，請輸入正確電話號碼'))
        } else if (this.isCellphoneRigistrated === true && this.exceptionState === 'register') {
          return callback(new Error('此手機已經註冊過，請更換申請號碼！'))
        } else if (this.isCellphoneRigistrated === false && this.exceptionState === 'forget1') {
          return callback(new Error('此手機尚未註冊'))
        } else {
          callback()
        }
        break
      case 'verificationCode':
        if (!value) {
          return callback(new Error('手機驗證碼不可為空'))
        } else if (this.isVerificationCodeError) {
          return callback(new Error('驗證碼錯誤，請重新輸入'))
        } else {
          callback()
        }
        break
      case 'password':
        if (!value) {
          return callback(new Error('密碼不可為空'))
        } else if (!passwordRegex.test(value)) {
          return callback(new Error('密碼格式錯誤，請輸入6位數字'))
        } else {
          callback()
        }
        break
      case 'password2':
        if (!value) {
          return callback(new Error('確認密碼不可為空'))
        } else if (value !== this.registerData.password) {
          return callback(new Error('兩次密碼不一致，請重新輸入'))
        } else {
          callback()
        }
        break
      default:
        callback()
        break
      }
    }
    const checkFormChange = (rule, value, callback) => {
      const passwordRegex = /^\d{6}$/
      if (rule.field === 'cellphone') {
        if (!isValidCellphone(value)) {
          this.canSendVerificationCode = false
        } else {
          this.canSendVerificationCode = true
        }
      }
      if (this.haveSendedRegister) {
        switch (rule.field) {
        case 'name':
          if (!value) {
            return callback(new Error('姓名不可為空'))
          } else {
            callback()
          }
          break
        case 'cellphone':
          if (!value) {
            return callback(new Error('手機號碼不可為空'))
          } else if (value.length === 10 && !isValidCellphone(value)) {
            return callback(new Error('手機格式錯誤，請輸入正確電話號碼'))
          } else {
            callback()
          }
          break
        case 'verificationCode':
          if (!value) {
            return callback(new Error('手機驗證碼不可為空'))
          } else {
            callback()
          }
          break
        case 'password':
          if (!value) {
            return callback(new Error('密碼不可為空'))
          } else if (value.length === 6 && !passwordRegex.test(value)) {
            return callback(new Error('密碼格式錯誤，請輸入6位數字'))
          } else {
            callback()
          }
          break
        case 'password2':
          if (!value) {
            return callback(new Error('確認密碼不可為空'))
          } else if (value.length === 6 && value !== this.registerData.password) {
            return callback(new Error('兩次密碼不一致，請重新輸入'))
          } else {
            callback()
          }
          break
        default:
          callback()
          break
        }
      }
    }
    return {
      pageLoading: false,
      showBrowserNotify: false,
      collapseLinkBox: false, // 手機版header連結
      tabActive: 'tab-username', // tab-username, tab-qrcode
      loginState: 'login', // loign, community
      exceptionState: 'login', // login, select, forget, temppwd, register, registerSuccess
      latitude: 0,
      longitude: 0,
      accountRemember: false,
      lastLoginUser: null,
      loginAuth: {
        username: '',
        password: '',
        tempSn: ''
      },
      loginData: {
        communityLoginToken: '', // 帳密Token，拿來取得社區清單用，且只有帳密登入時會有值
        communityAdminToken: '', // 可以開通新社區或刷新社區列表(GetCommunitysWithToken)
        authInfoToken: '',
        pushToken: '',
        qrcodeToken: '',
        qrcodeTokenDueTime: '',
        qrcodeData: '',
        qrcodeDue: false,
        qrcodeTimer: null,
        adminName: '',
        communities: [],
        isAuthorizationAccount: false // 是否為實名制帳號
      },
      loginAuthRules: {
        username: [
          { required: true, message: '請輸入帳號', trigger: 'change' }
        ],
        password: [
          { required: true, message: '請輸入密碼', trigger: 'change' }
        ],
        tempSn: [
          { required: true, message: '請輸入臨時密碼', trigger: 'change' }
        ]
      },
      registerData: {
        name: '',
        cellphone: '',
        verificationCode: '',
        password: '',
        password2: ''
      },
      registerRules: {
        name: [
          { validator: checkForm, trigger: 'blur' },
          { validator: checkFormChange, trigger: 'change' }
        ],
        cellphone: [
          { validator: checkForm, trigger: 'blur' },
          { validator: checkFormChange, trigger: 'change' }
        ],
        verificationCode: [
          { validator: checkForm, trigger: 'blur' },
          { validator: checkFormChange, trigger: 'change' }
        ],
        password: [
          { validator: checkForm, trigger: 'blur' },
          { validator: checkFormChange, trigger: 'change' }
        ],
        password2: [
          { validator: checkForm, trigger: 'blur' },
          { validator: checkFormChange, trigger: 'change' }
        ]
      },
      isCellphoneRigistrated: null,
      isVerificationCodeError: false,
      verifyToken: '',
      timer: null,
      second: 180,
      canSendVerificationCode: false,
      haveSendedRegister: false,
      isSendingRegister: false,
      showTimer: false,
      isOpenCodeDialog: false,
      tempCellphone: '',
      isSmallScreen: !(document.body.clientWidth > 768),
      clientWidth: document.body.clientWidth,
      smsHintMessage: '',
      communityOpenDialogSetting: {
        isShowCancelAlert: false,
        isReLoginAlert: true
      },
      communitySelectTimer: null,
      communitySelectTimeout: 5 * 60 * 1000, // 5分鐘未選擇社區，將重新登入
      isCommunitySelectLoading: false, // 社區選擇頁loading
      openAndTimeoutFlag: false
    }
  },
  computed: {
    /**
     * 取得 store 中的 isForceLogout 狀態
     * @returns {boolean|null} 強制登出狀態
     */
    isForceLogout () {
      return this.$store.state.isForceLogout
    }
  },
  watch: {
    loginState (state) {
      switch (state) {
      case 'login':
        if (localStorage.getItem('username')) {
          this.loginAuth.username = localStorage.getItem('username')
          this.accountRemember = true
        }
        this.tabActive = 'tab-username'
        if (this.communitySelectTimer) {
          clearTimeout(this.communitySelectTimer)
          this.communitySelectTimer = null
        }
        this.openAndTimeoutFlag = false
        break
      case 'community':
        this.communitySelectTimer = setTimeout(() => {
          // 當時間到的時候，如果開啟社區開通對話框，則先不跳出alert
          // 直到關閉dialog，才跳出過時alert
          if (this.isOpenCodeDialog) {
            this.openAndTimeoutFlag = true
            return
          }
          this.$alert(this.$t('LoginMain.Timeout'), '', {
            confirmButtonText: '確定',
            type: 'warning',
            showClose: false,
            closeOnClickModal: false,
            callback: () => {
              this.logoutUser()
              this.loginState = 'login'
            }
          })
        }, this.communitySelectTimeout)
        break
      default:
      }
    },
    isOpenCodeDialog (state) {
      // 特殊情境：如果開啟社區開通對話框時，即使超時，也會讓他繼續使用
      // 直到關閉dialog，才跳出過時alert
      if (!state && this.openAndTimeoutFlag) {
        // 關閉時，且開啟社區開通對話框時，跳出alert
        this.$alert(this.$t('LoginMain.Timeout'), '', {
          confirmButtonText: '確定',
          type: 'warning',
          showClose: false,
          closeOnClickModal: false,
          callback: () => {
            this.logoutUser()
            this.loginState = 'login'
            this.openAndTimeoutFlag = false
          }
        })
      }
    },
    tabActive (state) {
      switch (state) {
      case 'tab-username':
        this.$nextTick(() => {
          this.$refs.loginUsernameDom.$refs.input.focus()
        })
        break
      case 'tab-qrcode':
        break
      default:
      }
    },
    'loginData.qrcodeData' (data) {
      if (data) {
        if (JSON.parse(localStorage.getItem('QRcodeToken'))) {
          const due = JSON.parse(localStorage.getItem('QRcodeToken')).due
          this.loginData.qrcodeDue = false
          clearInterval(this.loginData.qrcodeTimer)
          this.loginData.qrcodeTimer = setInterval(() => {
            const now = new Date().getTime()
            if (now - due >= 0) {
              this.loginData.qrcodeDue = true
              clearInterval(this.loginData.qrcodeTimer)
            }
          }, 1000)
        } else {
          this.generateQrcode()
        }
      }
    },
    second (newVal) {
      if (newVal === 0) {
        if (isValidCellphone(this.registerData.cellphone)) {
          this.canSendVerificationCode = true
        }
        this.clearTimer()
      }
    },
    exceptionState () {
      this.smsHintMessage = ''
    }
  },
  async mounted () {
    // issue: 由登入頁跳轉到首頁後，還在操作登入頁的 DOM，但該 DOM 已不存在
    // Sentry: MGMT-R2
    // 修正方式：若已自動登入跳轉到首頁，則不執行後續動作，避免操作到不存在的 DOM
    const isRedirected = await this.performAutoLogin()
    if (isRedirected) return

    localStorage.removeItem('communityMainService')
    if (this.$route.params.page === 'register' || this.$route.name === 'LoginMainRegister') { // 跳轉到登入頁，直接顯示實名制帳號（社區管理人員帳號）註冊頁面
      this.switchExceptionState('register')
      this.$logoutCommunity()
    }
    // 雲對講 Air（cloudintercom）功能頁的主要使用情境為 mobile 裝置，
    // 可能包含使用 Safari (或其他) 的用戶，不應被瀏覽器檢測阻擋。
    const isCloudIntercom = this.$route.path.includes('cloudintercom')
    if (this.detectBrowser() && !isCloudIntercom) {
      this.showBrowserNotify = true
      return false
    }
    this.longitude = this.$store.state.position.longitude
    this.latitude = this.$store.state.position.latitude
    if (localStorage.getItem('username')) {
      this.loginAuth.username = localStorage.getItem('username')
      this.accountRemember = true
    }
    console.log(this.$getCookie('comLoginToken')) // 等待api,判斷自動登入用
    this.$refs.loginUsernameDom.$refs.input.focus()

    this.$refs.registerSw.checkPermission()
    // if ('Notification' in window) {
    // Notification.requestPermission((permission) => {
    //   console.log(permission)
    //   // eslint-disable-next-line eqeqeq
    //   if (permission === 'granted') {
    //     this.$refs.registerSw.registerServiceWorker()
    //   } else {
    //     this.$refs.registerSw.checkPermission()
    //     console.log(localStorage.getItem('serviceWorker'))
    //   }
    // })
    // } else {
    // 身為 PD，希望可以默許使用 iPhone 版 Chrome 的情境，以避免零星客訴 #77798
    // 五年前想擋沒寫好、沒擋成功，零星使用者鑽漏洞使用，但也沒遇到相關客訴
    // 近期修 Sentry 把阻擋修好，反而造成客訴，經 PD 評估後不進行此阻擋
    // 若為使用手機所造成的客訴，RD 將不會進行處理
    // this.$alert('請檢查是否你的瀏覽器支援。', '警告', {
    //   confirmButtonText: '確定',
    //   type: 'warning',
    //   showClose: false,
    //   roundButton: true,
    //   closeOnClickModal: false
    // }).then(() => {
    //   // this.$logoutCommunity()
    // })
    // }
  },
  beforeDestroy () {
    if (this.communitySelectTimer) {
      clearTimeout(this.communitySelectTimer)
      this.communitySelectTimer = null
    }
    clearInterval(this.loginData.qrcodeTimer)
    window.removeEventListener('resize', this.onScreenWidthChange)
  },
  methods: {
    detectBrowser (browser) { // 偵測瀏覽器
      const sAgent = navigator.userAgent.toLowerCase()
      const isCh = (sAgent.indexOf('chrome') !== -1)// chrome
      const isChIOS = (sAgent.indexOf('crios') !== -1)// chrome for ios
      const isOther = (!isCh && !isChIOS)
      window.localStorage.Promotion = 1
      return isOther
    },
    /**
     * 等待 isForceLogout 狀態變為非 null 值
     * 使用 watch store state 的方式監聽 isForceLogout 狀態變化
     * @returns {Promise<boolean>} 回傳 isForceLogout 的最終值
     */
    waitForIsForceLogout () {
      return new Promise(resolve => {
        if (this.isForceLogout !== null) return resolve(this.isForceLogout)

        const unwatch = this.$watch('isForceLogout', (val) => {
          if (val !== null) {
            unwatch()
            resolve(val)
          }
        })
      })
    },
    /**
     * 取得並儲存用戶資訊
     * 驗證登入 token 是否有效，如果有效則將用戶資訊儲存到 localStorage 並設定第三方服務
     * @returns {Promise<boolean>} 如果驗證成功且已儲存用戶資訊則返回 true，否則返回 false
     */
    async fetchAndStoreUserInfo () {
      const loginToken = this.$getCookie('comLoginToken')
      if (!loginToken) return false
      this.pageLoading = true
      try {
        const { data } = await housekeeperAPI.getLoginInfo()
        const userData = data.Data
        if (!userData?.ExpireTime) {
          return false
        }

        const currentTime = new Date().getTime()
        const expireTime = new Date(userData.ExpireTime).getTime()
        if (expireTime <= currentTime) {
          // 如果是登入過期，則把登入狀態都清乾淨
          this.$logoutCommunity()
          return false
        }

        // 儲存用戶資訊到 localStorage 並設定第三方服務
        localStorage.setItem('loginUserInfo', JSON.stringify(userData))
        this.$infobipSetUser(userData)

        // 確認該社區、該人員是否需強制登出
        await this.waitForIsForceLogout()
        if (this.isForceLogout) {
          return false
        }

        return true
      } catch (error) {
        console.error('Failed to fetch user info:', error)
        return false
      } finally {
        this.pageLoading = false
      }
    },
    /**
     * 執行自動登入
     * 在頁面初始化時檢查是否有有效的登入狀態，如果有效則自動跳轉到主頁面
     * @async
     * @returns {Promise<void>}
     */
    async performAutoLogin () {
      const isInfoValid = await this.fetchAndStoreUserInfo()
      if (isInfoValid) {
        this.$toMainPage()
      }
      return isInfoValid
    },
    loginBySn () { // 使用臨時密碼登入
      this.$refs.loginTempSnDom.validate((valid) => {
        if (valid) {
          this.pageLoading = true
          const ua = UAParser()
          const postData = {
            Sn: this.loginAuth.tempSn,
            Latitude: this.latitude,
            Longitude: this.longitude,
            UserAgent: {
              Browser: {
                Name: ua.browser.name,
                Version: ua.browser.version
              },
              Os: {
                Name: ua.os.name,
                Version: ua.os.version
              }
            }
          }
          const url = process.env.NODE_ENV === 'development' ? '/localmvc/Login/OneSnLogin' : `${process.env.VUE_APP_MVC_URL}/Login/OneSnLogin`
          axios(url, {
            method: 'POST',
            data: postData
          }).then(async (res) => {
            this.pageLoading = false
            // eslint-disable-next-line eqeqeq
            if (res.data.Data == true) {
              const isInfoValid = await this.fetchAndStoreUserInfo()
              if (isInfoValid) {
                this.pageLoading = true
                localStorage.setItem('loginStatus', true)
                this.$toMainPage()
              } else {
                this.loginState = 'login'
              }
            }
          }).catch((err) => {
            this.pageLoading = false
            this.$alert(`${(err.response.data.ErrorMessage && err.response.data.ErrorMessage.Description) || '密碼有誤，請確認後再試一次'}`, '警告', {
              confirmButtonText: '確定',
              type: 'warning',
              showClose: false,
              roundButton: true,
              closeOnClickModal: false
            }).then(() => {})
          })
        } else {
          this.$message({
            message: '請輸入臨時密碼',
            type: 'warning'
          })
          return false
        }
      })
    },
    async loginByAccount () {
      const isValid = await this.validateLoginForm()
      if (!isValid) return

      try {
        this.pageLoading = true
        this.clearAllStorage()
        await this.handleAccountLogin()
      } catch (error) {
        console.error('登入失敗:', error)
      } finally {
        this.pageLoading = false
      }
    },
    handleCommunityOpenSuccess () {
      if (this.loginState === 'community') {
        // 如果已經在社區選擇頁，則直接重新載入社區資料
        this.loadCommunityData({
          CommunityAdminToken: this.loginData.communityAdminToken
        })
      } else {
        // 如果沒有社區時，立即開通新社區，開通完成後，幫她登入
        this.loginByAccount()
      }
    },
    async validateLoginForm () {
      return new Promise(resolve => {
        this.$refs.loginAccountDom.validate(valid => {
          if (!valid) {
            this.$message({
              message: '請輸入帳號與密碼',
              type: 'warning'
            })
          }
          resolve(valid)
        })
      })
    },
    // 帳號密碼登入
    async handleAccountLogin () {
      try {
        const data = {
          Account: this.loginAuth.username,
          Password: this.loginAuth.password,
          Latitude: this.latitude,
          Longitude: this.longitude
        }
        const res = await apiMvc.checkAccountPassword(data)
        const resData = res.data.Data
        this.loginData.adminName = resData.AdminName
        this.loginData.communityLoginToken = resData.CommunityLoginToken
        this.loginData.isAuthorizationAccount = resData.IsAuthorizationAccount
        this.communitySelectTimeout = 5 * 60 * 1000 // 使用帳密登入時，五分鐘後超時
        if (!this.loginData.isAuthorizationAccount) {
          // 非實名制，顯示警告
          await this.handleLegacyAccount(resData)
          return
        }
        if (this.accountRemember) {
          localStorage.setItem('username', this.loginAuth.username)
        } else {
          localStorage.removeItem('username')
        }
        await this.loadCommunityData({
          CommunityLoginToken: this.loginData.communityLoginToken
        })
      } catch (err) {
        this.$sendGAEvent('登入', {
          value: `click_登入_失敗_${this.loginAuth.username}`
        })
        this.pageLoading = false
        document.activeElement.blur()
        const ErrorCode = err?.response?.data?.ErrorMessage?.Code
        switch (ErrorCode) {
        case 400002: {
          // 帳號密碼錯誤 / 實名制停用
          const errorDescription = err?.response?.data?.ErrorMessage?.Description
          this.$alert(`${errorDescription || '帳號密碼錯誤'}`, '警告', {
            showCancelButton: true,
            cancelButtonText: '忘記密碼',
            cancelButtonClass: 'el-button--danger',
            confirmButtonText: '確定',
            type: 'warning',
            showClose: false,
            roundButton: true,
            closeOnClickModal: false,
            callback: this.handleForgetOrNot
          }).then(() => {})
          break
        }
        case 400004:
          // 無開通社區
          this.loginData.communityAdminToken = err.response.data.Data.CommunityAdminToken
          this.communityOpenDialogSetting.isShowCancelAlert = true
          this.communityOpenDialogSetting.isReLoginAlert = false
          this.isOpenCodeDialog = true
          break
        case 400005:
          // 非實名制且停用
          this.$confirm('<span style="color: #c44536">登入失敗，因應系統更新，將不再支援舊制帳號登入，請重新註冊新制「社區管理人員帳號」。</span><br>為避免後續無法登入操作系統，請點選「前往註冊」，<a href="https://www.smartdaily.com.tw/sign-up-course/" style="color: #419f7d;text-decoration: underline;" target="_blank" rel="noopener">若有問題請查看詳細註冊說明</a>', '提示', {
            confirmButtonText: '前往註冊',
            showCancelButton: false,
            closeOnClickModal: false,
            dangerouslyUseHTMLString: true,
            type: 'warning'
          }).then(() => {
            this.switchExceptionState('register')
          }).catch(() => {
          })
          break
        default:
          this.$message.error('發生未知錯誤，請稍後再試')
          break
        }
      } finally {
        this.pageLoading = false
      }
    },
    // 顯示非實名制帳號警告
    async handleLegacyAccount (authData) {
      try {
        const result = await this.$confirm(
          '<span style="color: #c44536">因應系統更新，此帳號即將失效，將不再支援舊制帳號登入，請完成註冊新制「社區管理人員帳號」。</span><br>為避免後續無法登入操作系統，請點選「前往註冊」，<a href="https://www.smartdaily.com.tw/sign-up-course/" style="color: #419f7d;text-decoration: underline;" target="_blank" rel="noopener">若有問題請查看詳細註冊說明</a>',
          '提示',
          {
            confirmButtonText: '前往註冊',
            cancelButtonText: '下次再說',
            showClose: false,
            closeOnClickModal: false,
            dangerouslyUseHTMLString: true,
            type: 'warning'
          }
        )
        if (result === 'confirm') {
          // 使用者選擇"前往註冊"，則登出
          this.logoutUser()
          this.switchExceptionState('register')
        }
      } catch {
        // 使用者選擇"下次再說", 則走正常登入流程
        await this.loadCommunityData({
          CommunityLoginToken: this.loginData.communityLoginToken
        })
      }
    },
    /**
     * 載入社區列表資料、並進入社區選擇頁
     * @param {Object} tokenObj - 認證 token 物件 { CommunityLoginToken: "" } or { CommunityAdminToken: "" }
     */
    async loadCommunityData (tokenObj) {
      try {
        if (this.openAndTimeoutFlag) {
          // 如果此時已超時，則不會進行社區資料的載入
          return
        }
        this.isCommunitySelectLoading = true
        const res = await apiMvc.getCommunitysWithToken(tokenObj)
        this.isCommunitySelectLoading = false // 給在社區選擇頁開通社區時，重整資料的loading
        this.pageLoading = false // 給直接登入時，取得資料的loading
        this.loginData.communityAdminToken = res.data.Data.CommunityAdminToken
        this.loginData.communities = res.data.Data.Communities.map((val) => {
          const com = {
            comId: val.Id,
            comName: val.CommunityName,
            city: val.City,
            area: val.Area
          }
          return com
        })
        this.loginState = 'community'
        this.$sendGAEvent('登入', {
          value: `click_登入_成功_${this.loginAuth.username}`
        })
      } catch (err) {
        console.error('載入社區資料失敗:', err)
      }
    },
    // 使用掃描登入
    loginByQrcode (data) {
      this.pageLoading = true
      this.loginData.authInfoToken = data.AuthorizationInfoToken
      this.loginData.adminName = data.AdminName
      this.loginData.qrcodeToken = JSON.parse(localStorage.getItem('QRcodeToken')).token
      const postData = {
        authorizationInfoToken: this.loginData.authInfoToken
      }
      const url = process.env.NODE_ENV === 'development' ? '/localmvc/ServiceWorker/getAuthorizationComId' : `${process.env.VUE_APP_MVC_URL}/ServiceWorker/getAuthorizationComId`
      axios(url, {
        method: 'GET',
        params: postData
      }).then((res) => {
        this.pageLoading = false
        const oriArr = res.data.Data.ComIds
        const comArr = oriArr
          .map(e => e.com_id)
          // store the keys of the unique objects
          .map((e, i, final) => final.indexOf(e) === i && i)
          // eliminate the dead keys & store unique objects
          .filter(e => oriArr[e]).map(e => oriArr[e])
        this.loginData.communities = comArr.map((val) => {
          const com = {
            comId: val.com_id,
            comName: val.com_name
          }
          return com
        })
        this.loginData.isAuthorizationAccount = true // 此處後端未給值，但是流程上管理版App只有實名制帳號可以掃碼登入
        this.loginData.communityAdminToken = res.data.Data.CommunityAdminToken
        this.communitySelectTimeout = JSON.parse(localStorage.getItem('QRcodeToken')).due - new Date().getTime()
        this.loginState = 'community'
      }).catch((err) => {
        console.log(err)
        console.log(err.response)
        this.pageLoading = false
        this.$message({
          message: 'Qrcode登入錯誤，請稍後再試。',
          type: 'warning'
        })
      })
    },
    // 選定社區登入
    confirmLogin (comId, comName) {
      // eslint-disable-next-line eqeqeq
      if (!this.lastLoginUser || !this.lastLoginUser.CommunityName || (this.lastLoginUser && this.lastLoginUser.CommunityName != comName)) {
        this.clearStorageAsSwitchCommunity()
      }
      if (this.loginData.communityLoginToken) { // 帳號登入
        this.pageLoading = true
        const ua = UAParser()
        const postData = {
          Token: this.loginData.communityLoginToken,
          ComId: comId,
          BrowserPushToken: this.loginData.pushToken,
          UserAgent: {
            Browser: {
              Name: ua.browser.name,
              Version: ua.browser.version
            },
            Os: {
              Name: ua.os.name,
              Version: ua.os.version
            }
          }
        }
        const url = process.env.NODE_ENV === 'development' ? '/localmvc/Login/CommunityLogin' : `${process.env.VUE_APP_MVC_URL}/Login/CommunityLogin`
        axios(url, {
          method: 'POST',
          data: postData
        }).then(async (res) => {
          this.pageLoading = false
          const isInfoValid = await this.fetchAndStoreUserInfo()
          if (isInfoValid) {
            localStorage.setItem('loginStatus', true)
            this.pageLoading = true
            this.$toMainPage()
          } else {
            this.loginState = 'login'
          }
        }).catch((err) => {
          console.log(err)
          console.log(err.response)
          this.pageLoading = false
          this.$message({
            message: '登入錯誤',
            type: 'warning'
          })
        })
      } else if (this.loginData.qrcodeToken) { // qrcode登入
        if (this.loginData.authInfoToken && this.loginData.qrcodeToken) {
          this.pageLoading = true
          const ua = UAParser()
          const postData = {
            authorizationInfoToken: this.loginData.authInfoToken,
            token: this.loginData.qrcodeToken,
            comId,
            latitude: this.latitude,
            longitude: this.longitude,
            UserAgent: {
              Browser: {
                Name: ua.browser.name,
                Version: ua.browser.version
              },
              Os: {
                Name: ua.os.name,
                Version: ua.os.version
              }
            }
          }
          const url = process.env.NODE_ENV === 'development' ? '/localmvc/ServiceWorker/AuthorizationLogin' : `${process.env.VUE_APP_MVC_URL}/ServiceWorker/AuthorizationLogin`
          axios(url, {
            method: 'GET',
            params: postData
          }).then(async (res) => {
            this.pageLoading = false
            if (res.data.Data === true) {
              try {
                await this.fetchAndStoreUserInfo()
              } catch (error) {
                console.log(error)
              }
              const isInfoValid = await this.fetchAndStoreUserInfo()
              if (isInfoValid) {
                localStorage.setItem('loginStatus', true)
                this.pageLoading = true
                this.$toMainPage()
              } else {
                this.loginState = 'login'
              }
            } else {
              this.$message({
                message: '登入錯誤',
                type: 'warning'
              })
            }
          }).catch((err) => {
            console.log(err)
            console.log(err.response)
            this.pageLoading = false
            if (err.response.data.ErrorMessage && err.response.data.ErrorMessage.Code === 400001) {
              this.$message({
                message: `${err.response.data.ErrorMessage.Description}，請重新登入`,
                type: 'warning'
              })
              this.loginState = 'login'
            } else {
              this.$message({
                message: '登入錯誤，請重新登入',
                type: 'warning'
              })
              this.loginState = 'login'
            }
          })
        } else {
          this.$message({
            message: 'qrcode登入異常',
            type: 'warning'
          })
        }
      } else {
        console.log('唉呀，登入壞掉了！')
      }
    },
    logoutUser () { // 登出
      if (this.loginData.communityLoginToken) { // 帳號登出
        this.loginData.token = ''
        this.loginAuth.username = ''
        this.loginAuth.password = ''
        this.loginState = 'login'
      } else if (this.loginData.qrcodeToken) { // qrcode登出
        this.pageLoading = true
        const postData = {
          Token: this.loginData.qrcodeToken
        }
        const url = process.env.NODE_ENV === 'development' ? '/localmvc/ServiceWorker/QRcodeLogout' : `${process.env.VUE_APP_MVC_URL}/ServiceWorker/QRcodeLogout`
        axios(url, {
          method: 'POST',
          data: postData
        }).then((res) => {
          console.log(res)
          this.loginData.qrcodeToken = ''
          this.pageLoading = false
          this.loginState = 'login'
        }).catch((err) => {
          console.log(err)
          console.log(err.response)
          this.pageLoading = false
          if (err.response.data.ErrorMessage && err.response.data.ErrorMessage.Code === 400001) {
            this.$message({
              message: `${err.response.data.ErrorMessage.Description}，請重新登入`,
              type: 'warning'
            })
            this.loginState = 'login'
          } else {
            this.$message({
              message: 'Qrcode登出失敗，請重新登入',
              type: 'warning'
            })
            this.loginState = 'login'
          }
        })
      } else {
        console.log('唉呀，登出壞掉了')
      }
    },
    // 判斷該pushToken是否有登入過，若有則提示「確定要登入...」，若無則取得新的推播token
    isLogin (pushToken) {
      console.log('isLogin:', pushToken)
      this.pageLoading = true
      const postData = {
        BrowserPush: pushToken
      }
      this.loginData.pushToken = pushToken
      const url = process.env.NODE_ENV === 'development' ? '/localmvc/ServiceWorker/isLoginByBrowserPush' : `${process.env.VUE_APP_MVC_URL}/ServiceWorker/isLoginByBrowserPush`
      axios(url, {
        method: 'GET',
        params: postData
      }).then((res) => {
        if (res.data.Status === 1 && (res.data.Data.ComIds || res.data.Data.Token || res.data.Data.dCode || res.data.Data.AdminName)) {
          this.loginData.authInfoToken = res.data.Data.dCode
          this.loginData.qrcodeToken = res.data.Data.Token
          this.loginData.adminName = res.data.Data.AdminName
          this.loginData.communityAdminToken = res.data.Data.CommunityAdminToken
          this.loginData.isAuthorizationAccount = true // 此處後端未給值，但是流程上管理版App只有實名制帳號可以掃碼登入
          this.loginData.communities = res.data.Data.ComIds.map((val) => {
            const com = {
              comId: val.ComId,
              comName: val.ComName
            }
            return com
          })
          this.pageLoading = false
          this.$confirm(`確定要登入 【管理員 ${this.loginData.adminName}】選擇社區頁面嗎?`, '提示', {
            confirmButtonText: '確定',
            cancelButtonText: '取消',
            type: 'warning',
            roundButton: true,
            closeOnClickModal: false
          }).then(() => {
            this.loginState = 'community'
          }).catch(() => {
            this.logoutUser()
            this.getNewPushToken()
          })
        } else {
          console.log('addBrowserPush')
          this.pageLoading = false
          this.getNewPushToken()
        }
      }).catch((err) => {
        console.log('isLogin', err)
        console.log(err.response)
        this.pageLoading = false
        this.$message({
          message: '發生未知錯誤，請稍後再試',
          type: 'warning'
        })
      })
    },
    getNewPushToken () { // 取得新的推播token  (取得新的token並置換)
      const postData = {
        BrowserPush: this.loginData.pushToken
      }
      const url = process.env.NODE_ENV === 'development' ? '/localmvc/ServiceWorker/AddValidBrowser' : `${process.env.VUE_APP_MVC_URL}/ServiceWorker/AddValidBrowser`
      axios(url, {
        method: 'POST',
        data: postData
      }).then((res) => {
        if (res.data.Status === 1) {
          this.loginData.qrcodeToken = res.data.Data.Token
          this.loginData.qrcodeTokenDueTime = res.data.Data.ValidityPeriod
          localStorage.setItem('serviceWorker', 'true')
          this.generateQrcode()
        }
      }).catch((err) => {
        console.log(err)
        console.log(err.response)
        this.$message({
          message: '取得Qrcode失敗請稍後再試，請稍後再試',
          type: 'warning'
        })
      })
    },
    generateQrcode () { // 產生qrcode
      if (this.loginData.qrcodeToken) {
        this.loginData.qrcodeData = this.loginData.qrcodeToken
        this.qrcodeDue = false
        const QRcodeToken = {
          token: this.loginData.qrcodeToken,
          due: new Date(this.loginData.qrcodeTokenDueTime).getTime()
        }
        localStorage.setItem('QRcodeToken', JSON.stringify(QRcodeToken))
      } else {
        this.$message({
          message: '產生Qrcode失敗，請稍後再試',
          type: 'warning'
        })
      }
    },
    handleTabClick (tab, event) { // 更換登入方式tab
      if (this.tabActive === 'tab-qrcode') {
        if ('serviceWorker' in navigator) {
          if (JSON.parse(localStorage.getItem('QRcodeToken'))) {
            const QRcodeDue = JSON.parse(localStorage.getItem('QRcodeToken')).due
            if (new Date().getTime() - QRcodeDue >= 0) { // 已過期
              this.$refs.registerSw.registerServiceWorker()
            } else {
              this.loginData.qrcodeData = JSON.parse(localStorage.getItem('QRcodeToken')).token
            }
          } else {
            this.$refs.registerSw.registerServiceWorker()
          }
        } else {
          this.$message({
            message: '您的瀏覽器不支援此功能',
            type: 'warning'
          })
          setTimeout(() => {
            this.tabActive = 'tab-username'
          }, 600)
        }
      }
    },
    handleReloadQrcode () { // 重新生成Qrcode
      this.$refs.registerSw.registerServiceWorker()
    },
    handleClickEnter (e) { // 按下enter
      switch (this.loginState) {
      case 'login':// login, select, forget, temppwd
        switch (this.exceptionState) {
        case 'login':
          switch (this.tabActive) {
          case 'tab-username':
            this.loginByAccount()
            break
          default:
          }
          break
        case 'temppwd':
          this.loginBySn()
          break
        default:
        }
        break
      case 'community':

        break
      default:
      }
    },
    clearIndexDB () { // 清除 indexDB
      function clearIndexDB (databaseName) {
        const req = indexedDB.deleteDatabase(databaseName)
        req.onsuccess = function () {
          console.log('Deleted database successfully')
        }
        req.onerror = function () {
          console.log("Couldn't delete database")
        }
        req.onblocked = function () {
          console.log("Couldn't delete database due to the operation being blocked")
        }
      }
      clearIndexDB('comBaseData')
      clearIndexDB('comCustomData')
      clearIndexDB('postalInfo')
      clearIndexDB('tabletInfo')
    },
    clearStorage () { // 清除 localStorage
      if (localStorage.getItem('loginUserInfo') && JSON.parse(localStorage.getItem('loginUserInfo')) && JSON.parse(localStorage.getItem('loginUserInfo')).CommunityName) {
        this.lastLoginUser = JSON.parse(localStorage.getItem('loginUserInfo'))
      } else {
        this.lastLoginUser = null
      }

      /**
       * 需移除的 localStorage key 清單
       * @type {Set<string>}
       */
      // const removeLocalStorageKeySet = new Set([
      //   'loginStatus', // 登入狀態
      //   'loginUserInfo', // 登入資訊
      //   'jwtDue', // token 到期時間
      //   'getPushTokenTime', // 推播碼獲取時間
      //   'BA-alert', // 告警項目 - 公區
      //   'BA-private-alert', // 告警項目 - 私區
      //   'disasterAlert', // 告警項目 - 災防淹水
      //   'communityMainService' // 功能卡片
      // ])
      /**
       * 需保留的 localStorage key 清單
       * @type {Set<string>}
       */
      const keepLocalStorageKeySet = new Set([
        'techNum', // 引導提示
        'promptNum', // 文字提示
        'username', // 登入用的使用者名稱
        'despatcher_v2', // 登記中的包裹資料，先保留、後續切換不同社區時才會清掉
        'orderFoodPointTypeByCommunity', // 點餐各社區的點數類型記憶值
        'adModalStatus', // 蓋版廣告
        'hasSeenFinancialTour', // 看過財務系統首頁的導覽
        'hasSeenIncomeTour', // 看過財務系統收入的導覽
        'hasSeenExpenseTour', // 看過財務系統支出的導覽
        'hasSeenModalSettingsTour' // 看過財務系統管理的導覽
      ])
      // 採用倒序方式遍歷避免刪除元素時影響索引
      for (let i = localStorage.length - 1; i >= 0; i--) {
        const key = localStorage.key(i)
        if (!keepLocalStorageKeySet.has(key)) {
          // 無需保留則清除
          localStorage.removeItem(key)
        }
      }
      this.$copyLocalStorageToStore()
    },
    clearStorageAsSwitchCommunity () { // 更換社區才清除的暫存
      localStorage.removeItem('despatcher_v2')
    },
    clearAllStorage () { // 清除所有暫存
      this.clearIndexDB()
      this.clearStorage()
      sessionStorage.clear()
    },
    sendVerificationCode () {
      this.pageLoading = true
      if (!this.isSendingRegister) {
        this.isSendingRegister = true
        let url
        switch (this.exceptionState) {
        case 'register':
          url = `${process.env.VUE_APP_MAPI_URL}/Authorization/Web/SendRegisterVerification`
          break
        case 'forget1':
          url = `${process.env.VUE_APP_MAPI_URL}/Authorization/Web/SendResetPasswordVerification`
          break
        default:
          break
        }
        axios(url, {
          method: 'POST',
          data: {
            Phone: this.registerData.cellphone
          }
        }).then(res => {
          this.pageLoading = false
          this.isSendingRegister = false
          this.verifyToken = res.data.Data.Token
          this.tempCellphone = this.registerData.cellphone
          if (this.exceptionState === 'register' && res.data.Data.SendCount) {
            this.$alert(`<p>${this.$t('LoginMain.SendedSMSAlert1')}</p><p>${this.$t('LoginMain.SendedSMSAlert2')}</p>`, '', {
              dangerouslyUseHTMLString: true,
              type: 'success'
            }).catch(() => {})
            this.smsHintMessage = this.$t('LoginMain.SMSThreeTimesHint', { count: res.data.Data.SendCount })
          }
          this.showTimer = true
          this.timer = setInterval(() => {
            this.second--
          }, 1000)
        }).catch(err => {
          this.pageLoading = false
          this.isSendingRegister = false
          if (err.response.status === 403) {
            switch (this.exceptionState) {
            case 'register':
              this.isCellphoneRigistrated = true
              this.$refs.registerForm.validateField('cellphone')
              break
            case 'forget1':
              this.isCellphoneRigistrated = false
              this.$refs.forgetPasswordForm1.validateField('cellphone')
              break
            default:
              break
            }
          } else if (err.response.status === 406) {
            let errorMessage = err.response.data.ErrorMessage.Description
            if (err.response.data.ErrorMessage.Code === 406001) {
              if (this.exceptionState === 'register') {
                const time = err.response.data.Data?.AvailableTime ? this.getTimeLag(err.response.data.Data.AvailableTime) : ''
                errorMessage = this.$t('LoginMain.SMSThreeTimesErrorAlertWithTime', { time })
                this.smsHintMessage = this.$t('LoginMain.SMSThreeTimesErrorHintWithTime', { time })
              } else errorMessage = this.$t('LoginMain.SMSThreeTimesErrorAlert')
            }
            this.$alert(errorMessage, this.$t('General.AlertTitle'), {
              confirmButtonText: '確定',
              type: 'error',
              callback: action => {}
            })
          }
        })
      }
    },
    getTimeLag (nextDate) {
      const todayDate = new Date()
      const date = new Date(nextDate)
      const lagSec = (date - todayDate) / 1000
      const lagMin = lagSec / 60
      if (lagMin < 60) return `${Math.ceil(lagMin)} ${this.$t('LoginMain.Min')}`
      const lagHour = lagMin / 60
      return `${Math.ceil(lagHour)} ${this.$t('LoginMain.Hour')}`
    },
    checkVerificationCode (form) {
      const url = `${process.env.VUE_APP_MAPI_URL}/Authorization/Web/VerificationVerifyCode`
      return new Promise((resolve, reject) => {
        axios(url, {
          method: 'POST',
          data: {
            VerifyCode: this.registerData.verificationCode,
            VerifyToken: this.verifyToken
          }
        }).then(() => {
          this.isVerificationCodeError = false
          resolve()
        }).catch(err => {
          this.isVerificationCodeError = true
          this.$refs[form].validateField('verificationCode')
          this.isSendingRegister = false
          reject(err)
        })
      })
    },
    sendRegistration (form) {
      this.haveSendedRegister = true
      this.$refs[form].validate((valid) => {
        if (valid && !this.isSendingRegister) {
          if (this.tempCellphone !== this.registerData.cellphone) {
            this.isVerificationCodeError = true
            this.$refs[form].validateField('verificationCode')
            return false
          } else {
            this.isVerificationCodeError = false
          }
          if (form === 'registerForm') {
            this.checkVerificationCode(form)
              .then(res => {
                const url = `${process.env.VUE_APP_MAPI_URL}/Authorization/Web/Register`
                axios(url, {
                  method: 'POST',
                  data: {
                    Password: this.registerData.password,
                    Name: this.registerData.name,
                    VerifyCode: this.registerData.verificationCode,
                    NationalId: '',
                    VerifyToken: this.verifyToken
                  }
                }).then(res => {
                  this.$sendGAEvent('註冊狀態', {
                    value: 'click_註冊_成功'
                  })
                  this.exceptionState = 'registerSuccess'
                  this.isSendingRegister = false
                }).catch(err => {
                  this.$sendGAEvent('註冊狀態', {
                    value: 'click_註冊_失敗'
                  })
                  this.isSendingRegister = false
                })
              }).catch(err => {
                console.log(err)
              })
          } else if (form === 'forgetPasswordForm1') {
            this.checkVerificationCode(form)
              .then(res => {
                this.exceptionState = 'forget2'
                this.isSendingRegister = false
              }).catch(err => {
                console.log(err)
              })
          } else if (form === 'forgetPasswordForm2') {
            this.isSendingRegister = true
            const url = `${process.env.VUE_APP_MAPI_URL}/Authorization/Web/ResetPassword`
            axios(url, {
              method: 'POST',
              data: {
                Password: this.registerData.password,
                VerifyCode: this.registerData.verificationCode,
                VerifyToken: this.verifyToken
              }
            }).then(res => {
              this.$alert('重設密碼成功，請重新登入系統', '', {
                confirmButtonText: '確定',
                type: 'success',
                callback: action => {
                  this.closeRegister()
                }
              })
              this.isSendingRegister = false
            }).catch(err => {
              this.isSendingRegister = false
            })
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    closeRegister () {
      this.haveSendedRegister = false
      this.exceptionState = 'login'
      this.clearTimer()
      this.clearRegisterData()
    },
    clearTimer () {
      clearInterval(this.timer)
      this.second = 180
      this.showTimer = false
    },
    clearRegisterData () {
      this.registerData = {
        name: '',
        cellphone: '',
        verificationCode: '',
        password: '',
        password2: ''
      }
      this.$refs.registerForm.clearValidate()
      this.$refs.forgetPasswordForm1.clearValidate()
      this.$refs.forgetPasswordForm2.clearValidate()
    },
    filterValidValue (item) {
      const vm = this
      switch (item) {
      case 'name':
        vm.registerData.name = vm.registerData.name.replace(/[^\u4e00-\u9fa5a-zA-Z]/g, '')
        break
      case 'cellphone':
        vm.registerData.cellphone = vm.registerData.cellphone.replace(/[^0-9]/g, '')
        break
      case 'verificationCode':
        vm.registerData.verificationCode = vm.registerData.verificationCode.replace(/[^0-9]/g, '')
        break
      case 'password':
        vm.registerData.password = vm.registerData.password.replace(/[^0-9]/g, '')
        break
      case 'password2':
        vm.registerData.password2 = vm.registerData.password2.replace(/[^0-9]/g, '')
        break
      }
    },
    switchExceptionState (page) {
      if (page === 'register') {
        this.$sendGAEvent('註冊', {
          value: 'click_註冊'
        })
      }
      if (page === 'forget1') {
        this.$sendGAEvent('忘記密碼', {
          value: 'click_忘記密碼'
        })
      }
      this.exceptionState = page
      this.clearRegisterData()
    },
    handleForgetOrNot (action) {
      if (action === 'cancel') {
        this.switchExceptionState('forget1')
      }
    },
    backToLogin () {
      this.exceptionState = 'login'
      this.clearRegisterData()
    },
    openCommunityOpenDialog () {
      this.communityOpenDialogSetting.isShowCancelAlert = false
      this.communityOpenDialogSetting.isReLoginAlert = false
      this.isOpenCodeDialog = true
    }
  }
}
</script>
<style lang="sass" scoped>
body
  background-color: #fff
#login_main
  background-color: #fff
  input
    border: 1px solid $borderDark1
    &:focus
      border: 1px solid $mainColor
      outline: none
    &::-webkit-input-placeholder
      color: $subFontColor
      font-size: map-get($fontSize,small)
  .sm-size
    display: none
  .sm-size.collapse.in
    display: none
  .link
    text-align: center
    text-decoration: underline
    cursor: pointer
    font-size: 15px
  .mainText
    color: $mainColor
  .linkText
    color: $mainColorDark
  .dangerText
    color: $dangerColor
  .titleText
    font-size: map-get($fontSize,xx-large)
    font-weight: bold
    color: $mainFontColor
    margin-bottom: 21px
    text-align: center
  .subtitleText
    margin-bottom: 20px
    color: $mainFontColor
    text-align: center
  .mainBtn
    display: block
    font-family: inherit, sans-serif
    border: none
    width: 100%
    height: 45px
    margin: 0 auto
    background-color: $mainColor
    line-height: 47px
    color: #FFF
    font-size: map-get($fontSize,large)
    letter-spacing: 5px
    font-weight: bold
    text-align: center
    border-radius: $btnRoundBorderRadius
    cursor: pointer
    &:hover,&:focus
      background: $mainColorHover
      border-color: $mainColorHover
    &:active
      background: $mainColorActive
      border-color: $mainColorActive
  .optionBtn
    background-color: #fff
    color: $mainColor
    border: solid 2px $mainColor
    border-radius: $btnRoundBorderRadius
    font-weight: bold
    width: 300px
    min-height: 45px
    line-height: 20px
    display: flex
    align-items: center
    justify-content: center
    box-sizing: border-box
    padding: 0.3rem 1rem
    margin: 0 auto 20px
    cursor: pointer
    text-align: center
    &:hover,&:focus
      color: $mainColorHover
      border-color: $mainColorHover
      background: $defaultColorHover
    &:active
      color: $mainColorActive
      border-color: $mainColorActive
      background: $defaultColorActive
#loginDiv
  .loginDivWrap
    display: flex
    width: 100%
    min-width: 1000px
    min-height: 100vh
    .header
      font-size: map-get($fontSize,'medium')
      height: 70px
      padding: 20px 20px 0 20px
      box-sizing: border-box
      li a
        text-decoration: underline
    .main
      min-height: calc(100% - 150px)
      padding: 20% 20px 10%
      box-sizing: border-box
      .registerInput
        width: calc(100% - 137px)
        margin-right: 12px
      .messageWrap
        position: relative
        min-width: 120px
        .noMessageLink
          position: absolute
          top: 32px
          left: 0
      .noMessageLink
        color: $dangerColor
        text-decoration: underline
      .registerSuccess-container
        display: flex
        flex-direction: column
        align-items: center
        justify-content: center
        height: 100%
        gap: 2rem
        .icon-correct
          font-size: 90px
          color: $mainColorDark
        h3
          font-size: map-get($fontSize, xx-large)
          font-weight: bold
        .registerSuccessText
          font-size: map-get($fontSize, medium)
          color: $mainFontColor
          text-align: center
          p
            margin-bottom: 1rem
        button
          margin-top: 1rem
    .footer
      text-align: center
      padding: 0 20px 20px 20px
      box-sizing: border-box
      min-width: 320px
      .phone
        color: $mainFontColor
        margin: 0
        font-size: map-get($fontSize,'xx-large')
        .tip
          font-size: map-get($fontSize,'small')
      .copyRight
        font-size: map-get($fontSize,'x-small')
        color: $black
        line-height: 1.5
    .left
      width: 50%
      .header .header-brand img
        display: inline-block
        width: 90%
        min-width: 225px
        max-width: 260px
        vertical-align: text-top
      .main .main-pane
        width: 90%
        min-width: 320px
        max-width: 350px
        margin: auto
        ::v-deep .el-tabs
          +basicTabs
          text-align: center
          &__header
            margin-bottom: 40px
          &__nav
            float: initial
            display: inline-flex
            width: 100%
            padding: 0 0 5px
          &__item
            font-size: 16px
            flex: 1
            text-align: center
          #tab-qrcode
            p
              font-weight: bold
              &.tip
                letter-spacing: 1px
            .invalidTip
              display: none
            #loginQrcode
              min-height: 190px
              position: relative
              font-weight: bold
              margin-bottom: 10px
              canvas
                width: 185px
                height: 185px
              .reload
                position: absolute
                top: 50%
                left: 50%
                transform: translate(-50%, -50%)
                font-size: 60px
                display: none
                cursor: pointer
                z-index: 9
              .defaultPattern
                position: absolute
                left: 50%
                top: 50%
                transform: translate(-50%,-50%)
                width: 185px
                height: 185px
                line-height: 185px
                display: none
              &.default
                .defaultPattern
                  display: block
            &.invalid
              .invalidTip
                display: block
              #loginQrcode
                img
                  opacity: 0.2
                .reload
                  display: block
        .input-area
          position: relative
          margin-bottom: 30px
        .remember
          text-align: left
          margin-bottom: 20px
          color: $mainFontColor
        .errMsg
          display: none
          text-align: left
        .loginOptionBlock
          display: flex
          justify-content: center
          .cannotLogin
            padding: 20px 0
            margin: 0 10px
        .back
          text-align: center
          padding: 20px 0
        .login-solutionForget .mainText
          font-weight: bold
        .login-solutionSelect .optionWrap
          margin-top: 25px
        .login-solutionTemp
          .mainBtn
            margin-top: 10px
          .el-form-item
            margin: 10px 0 15px
        .login-procedure p
          line-height: 1.5
          margin-bottom: 5px
    .right
      width: 50%
      background: $mainColor
      .header
        text-align: right
        ul
          display: inline-flex
          width: 85%
          list-style: none
          padding: 0
          li
            flex: 1
            text-align: center
            align-self: center
            a
              display: inline-block
              font-weight: bold
              cursor: pointer
              color: $black
      .main .main-pane
        width: 400px
        margin: 0 auto
        img
          width: 100%
          margin-bottom: 35px
        p
          width: 80%
          margin: 0 auto
          line-height: 1.5
          color: $black
#communityDiv
  .communityDivWrap
    display: flex
    min-width: 768px
    min-height: 100vh
    .header
      margin-bottom: 200px
      padding: 20px
    .left
      background: $mainColor
      width: 35%
      .header
        .header-brand
        display: block
        text-align: center
        img
          display: inline-block
          width: 100%
          min-width: 225px
          max-width: 260px
          margin: 0 auto
      .main .main-pane img
        display: block
        width: 100%
        max-width: 400px
        margin: 0 auto
    .right
      position: relative
      background-color: $bgDark3
      width: 65%
      .main
        height: calc(100vh - 185px)
        display: flex
        flex-direction: column
        justify-content: center
        align-items: center
      .main .main-pane
        width: 90%
        min-width: 320px
        max-width: 500px
        text-align: center
        margin: auto
        .btnWrap
          display: inline-flex
          padding: 20px 80px 0px
          width: 150px
        span
          flex: 1
        .communityWrap p
          margin-bottom: 20px
        .communitySelect
          max-height: calc(100vh - 430px)
          overflow-y: auto
      .community-footer
        @media(max-width:768px)
          &
            display: block
            padding: 16px
            margin-bottom: 16px
            .footer-left
              margin-top: 10px
            .footer-right
              position: relative
              text-align: left !important
              margin-left: 145px
            .qr-code
              left: -145px
              bottom: 0
              top: unset !important
              transform: translateY(0) !important
              right: unset !important
        position: relative
        display: flex
        flex-direction: row-reverse
        justify-content: space-between
        align-items: flex-end
        word-wrap: nowrap
        margin-inline: 40px
        padding: 20px
        background-color: $white
        border-radius: 20px
        .footer-left
          text-align: left
          line-height: 26px
          color: $hintColor
          font-size: map-get($fontSize, small)
          .title
            color: $mainColor
            font-size: map-get($fontSize, medium)
            font-weight: bold
        .footer-right
          line-height: 26px
          text-align: center
          .title
            color: $mainFontColor
            font-size: map-get($fontSize, medium)
            font-weight: bold
          .property-link
            a
              color: $mainColor
              text-decoration: underline
              text-underline-offset: 3px
              font-size: map-get($fontSize, small)
        .qr-code
          position: absolute
          right: 19px
          top: 0
          transform: translateY(-50%)
          border-radius: 12px
          background-color: $mainColor
          padding: 10px
          .content
            background-color: $white
            border: $white solid 7px
            border-radius: 7px
            display: flex
            img
              width: 90px

@media (max-width:768px)
  #login_main
    .sm-size
      display: block
      margin: 0 auto
    .sm-size.collapse.in
      display: block
    #loginDiv
      .loginDivWrap
        min-width: 0
      .right
        display: none
      .left
        width: 100%
        .header
          width: 100%
          text-align: center
          position: relative
          .header-brand
            display: inline-block
          #burger-menu
            position: fixed
            width: 0
            top: 0
            right: 0
            height: 100vh
            z-index: 19
            background-color: $mainColor
            transition: width .6s ease-in-out
            &.in
              width: 100vw
            ul
              margin: 0
              padding: 0
              li
                color: #fff
                border-bottom: solid 1px #fff
                &:first-child
                  text-align: right
                  padding: 15px 20px
                  i
                    cursor: pointer
                a
                  display: inline-block
                  width: 100%
                  text-align: center
                  padding: 20px 20px
                  font-weight: bold
                  font-size: map-get($fontSize,large)
                  cursor: pointer
                  color: #fff
                  box-sizing: border-box
                  text-decoration: none
          .burger-bar
            position: absolute
            top: 29px
            right: 4%
            font-size: 22px
            cursor: pointer
        .main
          padding-top: 50px
          .main-pane
            flex: 1
            flex-direction: column
            display: flex
            img.sm-size
              width: 80%
            p.sm-size
              font-weight: normal
              line-height: 1.5
              color: $mainFontColor
          .registerSuccess-container
            margin-top: 2rem
          .el-form-item
            margin-bottom: 20px
            .registerInput
              width: 100%
              &.cellphoneInput
                width: calc(100% - 87px)
          .rigistrationBtn
            width: 100%
            margin: 16px 18px
          .link
            &.disable
              pointer-events: none
              color: #cccccc
        .footer
          background-color: $mainColor
          padding: 0
          overflow: hidden
          .phone
            background-color: #fff
            padding-bottom: 10px
          .copyRight
            padding: 5px
            line-height: 1.5
    #communityDiv
      .communityDivWrap
        min-width: 0
      .header
        margin-bottom: 50px
      .left
        display: none
      .right
        width: 100%
        background: $mainColor
        .header img
          height: 52px
          margin: auto
        .main .main-pane
          .optionBtn
            border: none
          .btnWrap span
            color: #fff
</style>
<style lang="sass" scoped>
.showBrowserDiv
  .modal-browser-overlay
    background-color: #000
    background-color: rgba(0,0,0,.4)
    position: fixed
    left: 0
    right: 0
    top: 0
    bottom: 0
    z-index: 99
  .modal-browser
    text-align: center
    width: 800px
    max-width: 100%
    height: 400px
    border-radius: 3px
    box-shadow: none
    border: none
    margin: 0
    position: fixed
    top: 50%
    left: 50%
    transform: translate(-50%, -50%)
    background-color: #fff
    padding: 15px 15px 10px 15px
    z-index: 99
    color: #333
    font-family: '微軟正黑體' , sans-serif
    h4
      font-size: map-get($fontSize,xx-large)
      margin-bottom: 12px
      margin-top: 60px
    p
      font-size: map-get($fontSize,large)
      margin-bottom: 12px
    div img
      width: 200px
      border: 0
</style>
